import { Box, Button, CircularProgress, Container, Grid, IconButton, ImageList, InputAdornment, TextField, Tooltip } from "@mui/material";
import React, { Component } from "react";
import Api from "src/services/api";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { styled, withStyles } from '@mui/styles';
import { Styles } from 'src/styles/material-styles';
import { Overlay } from 'src/styles/global';
import CustomizedSnackbars from 'src/components/material-snackbars';
import { FormattedMessage, injectIntl } from "react-intl";
import { AbilityContext } from "src/config/ability-context";
import PropTypes from 'prop-types';
import * as articleActions from 'src/redux/actions/articles';
import Header from "src/components/header-external";
import { PapiroConsole } from "src/utils/papiroConsole";
import BlockCard from "./components/block-card";
import Footer from "src/components/footer-external";
import Modal from "src/components/modal-external/modal-principal";
import MyMaterialTable from 'src/components/table'
import * as FileService from 'src/services/attachment.service';
import { AttachFile, FileCopy, Search } from "@mui/icons-material";
import DynamicArticles from "src/components/dynamic-articles-external";
import LogoMarca from 'src/images/new-logo2-cmtech.png'

const StyledTextField = styled(TextField)({
    backgroundColor: "rgb(232, 241, 250)",
    borderRadius: "14px",
    "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
    },
    "&.Mui-focused": {
        "& .MuiOutlinedInput-notchedOutline": {
            border: "none",
        }
    }
})

const classes2 = () => {
    return withStyles({
        ImageList: {
            width: "100%",
            height: 100,
        },
    });
}

class ClientPortalExternal extends Component {
    constructor(props) {
        super(props)
        const { userSession } = this.props;
        PapiroConsole.log("ClientPortal userSession")
        PapiroConsole.log(userSession)

        this.initalState = {
            id: 0,
            title: '',
            enablelogin: false,
            enablesearch: '',
            enablecreatecalled: false,
            searchtext: '',
            defaultcolor: '',
            clientportalblocks: [],
            showpromotedarticles: false,
            promotedarticlesamount: 0,
            showrecentarticles: false,
            recentarticlesamount: 0,
            showmostviewedarticles: false,
            mostviewedarticlesamount: 0,
            showbestratedarticles: false,
            bestratedarticlesamount: 0,
            footertext: '',
            footerphone: '',
            footeremail: '',
            showinstagram: '',
            instagramlink: '',
            showlinkedin: '',
            linkedinlin: '',
            showyoutube: '',
            youtubelink: '',
            showfacebook: '',
            facebooklink: '',
            defaulttextcolor: '',
            enablewebchat: false,
            enablefaq : false
        }

        this.state = {
            item: this.initalState,
            hirerid: 0,
            loading: false,
            openNotification: false,
            notificationVariant: 'error',
            notificationMessage: '',
            searchvalue: '',
            promotedarticles: [],
            bestratedarticles: [],
            mostviewedarticles: [],
            recentarticles: [],
            createCalledDialogOpen: false,
            calledServiceSettingsList: [],
            knowledgeBaseDialogOpen: false,
            knowledgeBaseDialogItem: { knowledgebaseknowledgebasekeywords: [], knowledgebaseattachments: [] },
            mainimagesrc: '',
            appName: Api != null ? Api.getAppName() : "CMTECH - Mexx 2DO",
            logoimagesrc: '',
            channelwebchat: {},
        }

        this.handleChange = this.handleChange.bind(this)
        this.openKnowledgeBaseDialog = this.openKnowledgeBaseDialog.bind(this)
        this.openCreateCalledDialog = this.openCreateCalledDialog.bind(this)
        this.closeKnowledgeBaseDialog = this.closeKnowledgeBaseDialog.bind(this)
        this.closeCreateCalledDialog = this.closeCreateCalledDialog.bind(this)
        this.setNotification = this.setNotification.bind(this)
        this.copyFileLink = this.copyFileLink.bind(this)
        this.downloadFile = this.downloadFile.bind(this)
        this.searchArticle = this.searchArticle.bind(this)
    }

    async componentDidMount() {
        document.title = this.state.appName;
        this.setState({ loading: true })
        await this.getHirerId()
        await this.getPortal()
        await this.getBlocks()
        if (this.state.item.mainimage != null && this.state.item.mainimage != 'undefined') {
            await this.getMainImageFile(this.state.item.mainimage)
        }
        this.setState({ loading: false })
    }

    getMainImageFile = async (image) => {
        try {
            const response = await fetch(image.anonymoustoken)

            if (!response.ok) {
                throw new Error('Erro ao buscar o link da imagem')
            }
            const json = await response.json()

            if (json?.data) {
                const imageUrl = json.data
                const mainImage = document.getElementById('mainimage');

                if (mainImage) {
                    mainImage.style.backgroundImage = `url(${imageUrl})`
                }
            }
        } catch (e) {
            PapiroConsole.log('Erro ao carregar imagem');
        }
    }

    handleChange = (e) => {
        const name = e.target.name
        const value = e.target.value

        this.setState({
            [name]: value
        })
    }

    setNotification = (openNotification, notificationVariant, notificationMessage) => {
        this.setState({
            openNotification: openNotification, notificationVariant: notificationVariant, notificationMessage: notificationMessage
        })
    }

    getHirerId = async () => {
        const intl = this.props.intl

        await Api.get(`/configs/cancreateclientusersexternal`)
            .then(result => {
                if (result.data.success) {
                    if (result.data.data != null) {
                        if (result.data.data.hirerid != null && result.data.data.hirerid > 0)
                            this.setState({ hirerid: result.data.data.hirerid })
                        else {
                            var l = this.props.match.params.lang;
                            document.location.href = `/${l}/unavailable`
                        }
                    }
                } else {
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: 'error',
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    });
                    Api.kickoff(result)
                }
            })
            .catch(err => {
                this.setState({
                    loading: false, openNotification: true, notificationVariant: 'error',
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                });
                Api.kickoff(err)
            })
    }

    getLogoImageFile = async (image) => {
        try {
            const response = await fetch(image.anonymoustoken)

            if (!response.ok) {
                throw new Error('Erro ao buscar o link da imagem')
            }

            const json = await response.json()

            if (json?.data) {
                const imageUrl = json.data
                this.setState({ logoimagesrc: imageUrl })
            }
        } catch (e) {
            PapiroConsole.log('Erro ao carregar imagem')
        }
    }

    getPortal = async () => {
        const intl = this.props.intl

        await Api.get(`/clientportal/external/hirer/${this.state.hirerid}`)
            .then(result => {
                if (result.data && result.data.success) {
                    this.setState({
                        item: result.data.data
                    })
                    if (result.data.data.logoimage) {
                        this.getLogoImageFile(result.data.data.logoimage)
                    } else {
                        const image = Api.getLoginImage()
                        if (image) {
                            this.getLogoImageFile(image)
                        } else {
                            this.setState({ logoimagesrc: LogoMarca })
                        }
                    }
                } else {
                    this.setState({ loading: false })
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({ loading: false })
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    getBlocks = async () => {
        const intl = this.props.intl

        await Api.get(`clientportalblocks/clientportal/${this.state.item.id}`)
            .then(result => {
                if (result.data.success) {
                    this.setState((prevState) => ({
                        ...prevState,
                        item: {
                            ...prevState.item,
                            clientportalblocks: result.data.data
                        }
                    }))
                }
                else {
                    this.setState({ loading: false })
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({ loading: false })
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })
    }

    openKnowledgeBaseDialog = async (knowledgebaseid) => {
        const intl = this.props.intl
        this.setState({ loading: true })

        await Api.get(`knowledgebases/details/external/${knowledgebaseid}`)
            .then(result => {
                if (result.data.success) {
                    this.setState({
                        knowledgeBaseDialogItem: result.data.data
                    })
                }
                else {
                    this.setState({ loading: false })
                    this.setState({
                        loading: false, openNotification: true, notificationVariant: "error",
                        notificationMessage: result.data && result.data.response && result.data.response.data && result.data.response.data.errors && result.data.response.data.errors[0] ? result.data.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                    })
                    Api.kickoff(result.data)
                }
            })
            .catch(err => {
                this.setState({ loading: false })
                this.setState({
                    loading: false, openNotification: true, notificationVariant: "error",
                    notificationMessage: err.response && err.response.data && err.response.data.errors && err.response.data.errors[0] ? err.response.data.errors[0] : intl.formatMessage({ id: "process.error" })
                })
                Api.kickoff(err)
            })

        this.setState({ loading: false })
        this.setState({ knowledgeBaseDialogOpen: true })
    }

    openCreateCalledDialog = (calledServiceSettingsList) => {
        this.setState({
            createCalledDialogOpen: true,
            calledServiceSettingsList: calledServiceSettingsList
        })
    }

    closeKnowledgeBaseDialog = () => {
        this.setState({ knowledgeBaseDialogOpen: false })
    }

    closeCreateCalledDialog = () => {
        this.setState({ createCalledDialogOpen: false })
    }

    closeNotification = () => {
        this.setState({ openNotification: false })
    }

    copyFileLink = async (attachment) => {
        const { intl } = this.props

        this.setState({ loading: true })

        let url = await FileService.getFileDownloadLink(attachment.id);
        if (url && url.data && url.data.data && url.data.success) {
            this.setState({ loading: false })
            navigator.clipboard.writeText(url.data.data)
            this.setNotification(true, "sucess", "Link de download copiado!")
        } else {
            this.setNotification(true, "sucess", intl.formatMessage({ id: "file.not.found" }))
        }

        this.setState({ loading: false })
    }

    downloadFile = async (attachment) => {
        const { intl } = this.props

        this.setState({ loading: true })

        let url = await FileService.getFileDownloadLink(attachment.id);
        if (url && url.data && url.data.data && url.data.success) {
            this.setState({ loading: false })
            window.open(`${url.data.data}`, '_blank')
        } else {
            this.setNotification(true, "sucess", intl.formatMessage({ id: "file.not.found" }))
        }

        this.setState({ loading: false })
    }

    searchArticle = () => {
        this.props.addCurrentSearch(this.state.searchvalue)
        this.props.history.push(`/${this.props.match.params.lang}/article-list-external`)
    }

    render() {

        const { classes, intl } = this.props
        const { item, hirerid, logoimagesrc } = this.state
        if (Api == null) {
            var l = this.props.match.params.lang;
            document.location.href = `/${l}/unavailable`
        }

        return (
            <div >
                <main
                    className={classes.contentExternal}
                >
                    <Container style={{ maxWidth: '100vw', width: '100vw', margin: 0, paddingInline: 0 }}>

                        <Grid container width="100%" direction="column" justifyContent="space-between" minHeight="100vh">
                            <Grid item container>
                                <Header
                                    intl={this.props.intl}
                                    clientportal={item}
                                    calledservicesettings={item.calledservicesettingsclientportals}
                                    language={this.props.match.params.lang}
                                    openCreateCalledDialog={this.openCreateCalledDialog}
                                    logoimagesrc={logoimagesrc}
                                />
                                <Grid item xs={12} sm={12} sx={{ paddingLeft: '0 !important', paddingTop: '0 !important' }}>
                                {
                                    item.mainimage ?
                                        <div id="mainimage" style={{ display: "block", width: "100vw", height: "300px", textAlign: "center", alignContent: "center" }}>
                                            {
                                                item.enablesearch &&
                                                <>
                                                    <h2 style={{ color: "white", marginBottom: "5px", fontWeight: "bold", fontSize: "24px" }}>
                                                        {item.searchtext}
                                                    </h2>
                                                    <StyledTextField
                                                        variant="outlined"
                                                        name="searchvalue"
                                                        className={classes.root}
                                                        label={intl.formatMessage({ id: "search" })}
                                                        value={this.state.searchvalue}
                                                        placeholder={intl.formatMessage({ id: "search.news.placeholder" })}
                                                        onChange={this.handleChange}
                                                        onKeyPress={(e) => {
                                                            if (e.key === 'Enter') {
                                                                this.searchArticle();
                                                            }
                                                        }}
                                                        color="primary"
                                                        sx={{
                                                            width: "600px"
                                                        }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={_ => this.searchArticle()}>
                                                                        <Search />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    >
                                                    </StyledTextField>
                                                </>
                                            }
                                        </div>
                                        :
                                        <div style={{ display: "block", width: "101vw", height: "300px", backgroundColor: item.defaultcolor, textAlign: "center", alignContent: "center" }}>
                                            {
                                                this.state.item.enablesearch &&
                                                <>
                                                    <h2 style={{ color: "white", marginBottom: "5px", fontWeight: "bold", fontSize: "24px" }}>
                                                        {item.searchtext}
                                                    </h2>
                                                    <StyledTextField
                                                        variant="outlined"
                                                        name="searchvalue"
                                                        label={intl.formatMessage({ id: "search" })}
                                                        value={this.state.searchvalue}
                                                        placeholder={intl.formatMessage({ id: "search.news.placeholder" })}
                                                        onChange={this.handleChange}
                                                        onKeyPress={(e) => {
                                                            if (e.key === 'Enter') {
                                                                this.searchArticle();
                                                            }
                                                        }}
                                                        color="primary"
                                                        sx={{ width: "600px", backgroundColor: "#fff" }}
                                                        InputProps={{
                                                            endAdornment: (
                                                                <InputAdornment position="end">
                                                                    <IconButton onClick={_ => this.searchArticle()}>
                                                                        <Search />
                                                                    </IconButton>
                                                                </InputAdornment>
                                                            )
                                                        }}
                                                    />
                                                </>
                                            }
                                        </div>
                                }
                            </Grid>
                                <Grid item container marginX="20vw" spacing={6} paddingTop={6} >
                                    <Grid item container spacing={3} >
                                        {
                                            this.state.item.clientportalblocks && this.state.item.clientportalblocks.map(block => {
                                                return (
                                                    <BlockCard
                                                        key={block.id}
                                                        block={block}
                                                        openKnowledgeBaseDialog={this.openKnowledgeBaseDialog}
                                                    />
                                                )
                                            })
                                        }
                                    </Grid>
                                    <Grid item container direction="row" spacing={1} justifyContent="space-around">
                                        {
                                            item.showpromotedarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "promoted.articles" })}
                                                hirerid={hirerid}
                                                type="promoted"
                                                count={item.promotedarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={item.defaulttextcolor}
                                            />
                                        }
                                        {
                                            item.showbestratedarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "best.rated.articles" })}
                                                hirerid={hirerid}
                                                type="bestrated"
                                                count={item.bestratedarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={item.defaulttextcolor}
                                            />
                                        }
                                        {
                                            item.showmostviewedarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "most.viewed.articles" })}
                                                hirerid={hirerid}
                                                type="mostviewed"
                                                count={item.mostviewedarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={item.defaulttextcolor}
                                            />
                                        }
                                        {
                                            item.showrecentarticles &&
                                            <DynamicArticles
                                                intl={intl}
                                                title={intl.formatMessage({ id: "recent.articles" })}
                                                hirerid={hirerid}
                                                type="recent"
                                                count={item.recentarticlesamount}
                                                setNotification={this.setNotification}
                                                defaulttextcolor={item.defaulttextcolor}
                                            />
                                        }
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Footer
                                intl={intl}
                                clientportal={this.state.item}
                                setLoading={loading => this.setState({ loading: loading })}
                            />
                        </Grid>

                        {this.state.loading && (
                            <Overlay>
                                <CircularProgress color='secondary' />
                            </Overlay>
                        )}

                        <CustomizedSnackbars
                            variant={this.state.notificationVariant}
                            message={this.state.notificationMessage}
                            isOpen={this.state.openNotification}
                            toClose={this.closeNotification}
                        />
                        <Modal
                            intl={intl}
                            id={this.state.knowledgeBaseDialogItem.id}
                            title={this.state.knowledgeBaseDialogItem.title}
                            open={this.state.knowledgeBaseDialogOpen}
                            onClose={this.closeKnowledgeBaseDialog}
                            children={
                                <Box sx={{ minHeight: '50px', maxHeight: '50vh', overflow: 'auto !important' }}>
                                    {(this.state.knowledgeBaseDialogItem.knowledgebaseknowledgebasekeywords && this.state.knowledgeBaseDialogItem.knowledgebaseknowledgebasekeywords.length > 0) && <Grid item xs={12} style={{ marginBottom: 15 }}>
                                        <h5><FormattedMessage id="keywords" />:</h5>
                                        <div className='kb-keys' style={{ justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                                            {this.state.knowledgeBaseDialogItem.knowledgebaseknowledgebasekeywords.map(item => {
                                                return <div className='kb-key' style={{ marginTop: 15 }}>{item.knowledgebasekeyword.word}</div>
                                            })}
                                        </div>
                                    </Grid>}
                                    {this.state.knowledgeBaseDialogItem.knowledgebaseattachments.length > 0 && (
                                        <Grid item xs={12}>
                                            <div className={classes.attachmentsBox}>
                                                <label>{<FormattedMessage id="attachments" />}</label>
                                                <ImageList cellHeight={100} className={classes2.ImageList} cols={1} >
                                                    <ul>
                                                        {this.state.knowledgeBaseDialogItem.knowledgebaseattachments.map(file => {
                                                            return (<li key={file.attachment.id}>
                                                                <AttachFile />
                                                                <Button onClick={() => this.downloadFile(file.attachment)}>
                                                                    {file.attachment.description}
                                                                </Button>
                                                                <Tooltip title={<h5>Copiar link de download</h5>}>
                                                                    <IconButton aria-label="textevidence"
                                                                        onClick={() => this.copyFileLink(file.attachment)}>
                                                                        <FileCopy />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </li>)
                                                        })}
                                                    </ul>
                                                </ImageList>
                                            </div>
                                        </Grid>
                                    )}
                                </Box>
                            }
                        />
                        <Modal
                            intl={intl}
                            title={intl.formatMessage({ id: "choose.form" })}
                            open={this.state.createCalledDialogOpen}
                            onClose={this.closeCreateCalledDialog}
                            contentPadding={false}
                            maxWidth="lg"
                            children={
                                <Box sx={{ minHeight: '50px' }}>
                                    <MyMaterialTable
                                        title=""
                                        columns={[
                                            { title: 'Id', field: 'id', width: "10%" },
                                            { title: intl.formatMessage({ id: "title" }), field: 'title' },
                                            { title: intl.formatMessage({ id: "organization" }), field: 'OrganizationText' },
                                            { title: 'Rota', field: 'RouteText', width: "50%" },
                                        ]}
                                        rowClick={(event, rowData) => {
                                            window.open(`${rowData.RouteText}`, '_blank')
                                        }}
                                        data={this.state.calledServiceSettingsList}
                                    />
                                </Box>
                            }
                        />
                    </Container>
                </main>
            </div>
        )
    }
}

ClientPortalExternal.propTypes = {
    classes: PropTypes.object.isRequired
}

const mapStateToProps = state => ({
    userSession: state.userSession,
})

const mapDispatchToProps = dispatch =>
    bindActionCreators(articleActions, dispatch);
export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(withStyles(Styles)(ClientPortalExternal)));
ClientPortalExternal.contextType = AbilityContext;